import { TableFilterTypes } from '@ge/models/constants';

export const CRTrackerColumns = {
  GROUP_MONTH: 'group-month',
  MONTH: 'month',

  GROUP_PROD: 'group-prod',
  PROD: 'prod',

  GROUP_LP: 'group-lp',
  LP: 'lp',

  GROUP_CONTRACTUAL_AVAILABILITY: 'group-contractual_availability',
  CONTRACTUAL_AVAILABILITY: 'contractual_availability',

  GROUP_MALS_ADDED: 'group-mals-added',
  MALS_ADDED: 'mals_added',

  GROUP_MALS_APPROVED: 'group-mals-approved',
  MALS_APPROVED: 'mals_approved',

  GROUP_MALS_REJECTED: 'group-mals-rejected',
  MALS_REJECTED: 'mals_rejected',

  GROUP_MALS_NOT_VALIDATED: 'group-mals-not-validated',
  MALS_NOT_VALIDATED: 'mals_not_validated',

  GROUP_LOCK_MONTH: 'group-lock-month',
  LOCK_MONTH: 'lock_month',

  GROUP_LOCK_MONTH_DATE: 'group-lock-month-date',
  LOCK_MONTH_DATE: 'lock_date',

  GROUP_LOCK_DONE_BY_SSO: 'group-locked-by',
  LOCK_DONE_BY_SSO: 'locked_by',

  GROUP_MALS_SUBMISSION_DATE: 'group-mals-after-lock',
  MALS_SUBMISSION_DATE: 'mals_after_lock',

  GROUP_STATUS_UPDATE: 'group-status-after-lock',
  STATUS_UPDATE: 'status_after_lock',
};

export const CRTrackerColumnDefs = {
  [CRTrackerColumns.GROUP_MONTH]: {
    cols: {
      [CRTrackerColumns.MONTH]: {
        align: 'left',
        minWidth: '140px',
        labels: [
          {
            a11yKey: 'table.month',
            a11yDefault: 'Reporting Month',
          },
        ],
      },
    },
  },
  // [CRTrackerColumns.GROUP_PROD]: {
  //   cols: {
  //     [CRTrackerColumns.PROD]: {
  //       align: 'left',
  //       minWidth: '140px',
  //       filterType: TableFilterTypes.NUMBER,
  //       labels: [
  //         {
  //           a11yKey: 'table.prod',
  //           a11yDefault: 'Actual Energy Production',
  //           sortValue: 'contractual_availability',
  //         },
  //       ],
  //     },
  //   },
  // },
  // [CRTrackerColumns.GROUP_LP]: {
  //   cols: {
  //     [CRTrackerColumns.LP]: {
  //       align: 'left',
  //       minWidth: '140px',
  //       filterType: TableFilterTypes.SEARCH,
  //       labels: [
  //         {
  //           a11yKey: 'table.lp',
  //           a11yDefault: 'Lock Period',
  //           sortValue: 'lp',
  //         },
  //       ],
  //     },
  //   },
  // },
  [CRTrackerColumns.GROUP_CONTRACTUAL_AVAILABILITY]: {
    cols: {
      [CRTrackerColumns.CONTRACTUAL_AVAILABILITY]: {
        align: 'left',
        minWidth: '140px',
        filterType: TableFilterTypes.NUMBER,
        labels: [
          {
            a11yKey: 'table.contractual_availability',
            a11yDefault: 'Contractual Availability (%)',
            sortValue: 'contractual_availability',
          },
        ],
      },
    },
  },
  [CRTrackerColumns.GROUP_MALS_ADDED]: {
    cols: {
      [CRTrackerColumns.MALS_ADDED]: {
        align: 'left',
        minWidth: '140px',
        filterType: TableFilterTypes.NUMBER,
        labels: [
          {
            a11yKey: 'table.mals_added',
            a11yDefault: '#MALs Created',
            sortValue: 'mals_added',
          },
        ],
      },
    },
  },
  [CRTrackerColumns.GROUP_MALS_APPROVED]: {
    cols: {
      [CRTrackerColumns.MALS_APPROVED]: {
        align: 'left',
        minWidth: '140px',
        filterType: TableFilterTypes.NUMBER,
        labels: [
          {
            a11yKey: 'table.mals_approved',
            a11yDefault: '#MALs Approved',
            sortValue: 'mals_approved',
          },
        ],
      },
    },
  },
  [CRTrackerColumns.GROUP_MALS_REJECTED]: {
    cols: {
      [CRTrackerColumns.MALS_REJECTED]: {
        align: 'left',
        minWidth: '140px',
        filterType: TableFilterTypes.NUMBER,
        labels: [
          {
            a11yKey: 'table.mals_rejected',
            a11yDefault: '#MALs Rejected',
            sortValue: 'mals_rejected',
          },
        ],
      },
    },
  },
  [CRTrackerColumns.GROUP_MALS_NOT_VALIDATED]: {
    cols: {
      [CRTrackerColumns.MALS_NOT_VALIDATED]: {
        align: 'left',
        minWidth: '140px',
        filterType: TableFilterTypes.NUMBER,
        labels: [
          {
            a11yKey: 'table.mals_not_validated',
            a11yDefault: '#MALs Pending Validation',
            sortValue: 'mals_not_validated',
          },
        ],
      },
    },
  },
  [CRTrackerColumns.GROUP_LOCK_MONTH]: {
    cols: {
      [CRTrackerColumns.LOCK_MONTH]: {
        align: 'left',
        minWidth: '140px',
        labels: [
          {
            a11yKey: 'table.lock_month',
            a11yDefault: 'Month Locked',
          },
        ],
      },
    },
  },
  [CRTrackerColumns.GROUP_LOCK_MONTH_DATE]: {
    cols: {
      [CRTrackerColumns.LOCK_MONTH_DATE]: {
        align: 'left',
        minWidth: '140px',
        filterType: TableFilterTypes.DATE,
        labels: [
          {
            a11yKey: 'table.lock_date',
            a11yDefault: 'Lock Date',
            sortValue: 'lock_date',
          },
        ],
      },
    },
  },
  [CRTrackerColumns.GROUP_LOCK_DONE_BY_SSO]: {
    cols: {
      [CRTrackerColumns.LOCK_DONE_BY_SSO]: {
        align: 'left',
        minWidth: '140px',
        filterType: TableFilterTypes.CHECKBOXES,
        labels: [
          {
            a11yKey: 'table.locked_by',
            a11yDefault: 'Locked By',
            sortValue: 'locked_by',
          },
        ],
      },
    },
  },
  [CRTrackerColumns.GROUP_MALS_SUBMISSION_DATE]: {
    cols: {
      [CRTrackerColumns.MALS_SUBMISSION_DATE]: {
        align: 'left',
        minWidth: '140px',
        filterType: TableFilterTypes.NUMBER,
        labels: [
          {
            a11yKey: 'table.mals_after_lock',
            a11yDefault: '#MALs submitted after lock',
            sortValue: 'mals_after_lock',
          },
        ],
      },
    },
  },
  [CRTrackerColumns.GROUP_STATUS_UPDATE]: {
    cols: {
      [CRTrackerColumns.STATUS_UPDATE]: {
        align: 'left',
        minWidth: '140px',
        filterType: TableFilterTypes.NUMBER,
        labels: [
          {
            a11yKey: 'table.status_after_lock',
            a11yDefault: '#MALs with status change after lock',
            sortValue: 'status_after_lock',
          },
        ],
      },
    },
  },
};
